module.exports = __webpack_public_path__ + "static/theme-photos-CGpifH-1-598bc90d640ed8c0df5fd9e02d5cf535.png";